import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 19H6V17H18V19ZM21 15H3V13H21V15ZM18 11H6V9H18V11ZM21 7H3V5H21V7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TextAlignCenter"
);
